/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ComparableQuestions } from '../models';
/**
 * ComparableQuestionsApi - axios parameter creator
 * @export
 */
export const ComparableQuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Endpoint to delete the report of the given ComparableQuestions.      Returns the updated ComparableQuestions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparableQuestionsControllerDeleteComparativeReport: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling comparableQuestionsControllerDeleteComparativeReport.');
            }
            const localVarPath = `/api/comparable-questions/{id}/comparative-report/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Endpoint to delete the given ComparableQuestions. Returns the list of remaining ComparableQuestions for the related ComparableEngagement
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparableQuestionsControllerDeleteOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling comparableQuestionsControllerDeleteOne.');
            }
            const localVarPath = `/api/comparable-questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate a comparative report for a given comparableQuestions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparableQuestionsControllerGenerateComparativeReport: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling comparableQuestionsControllerGenerateComparativeReport.');
            }
            const localVarPath = `/api/comparable-questions/{id}/generate-comparative-report`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComparableQuestionsApi - functional programming interface
 * @export
 */
export const ComparableQuestionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Endpoint to delete the report of the given ComparableQuestions.      Returns the updated ComparableQuestions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableQuestionsControllerDeleteComparativeReport(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ComparableQuestions>>> {
            const localVarAxiosArgs = await ComparableQuestionsApiAxiosParamCreator(configuration).comparableQuestionsControllerDeleteComparativeReport(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Endpoint to delete the given ComparableQuestions. Returns the list of remaining ComparableQuestions for the related ComparableEngagement
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableQuestionsControllerDeleteOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ComparableQuestions>>>> {
            const localVarAxiosArgs = await ComparableQuestionsApiAxiosParamCreator(configuration).comparableQuestionsControllerDeleteOne(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Generate a comparative report for a given comparableQuestions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableQuestionsControllerGenerateComparativeReport(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await ComparableQuestionsApiAxiosParamCreator(configuration).comparableQuestionsControllerGenerateComparativeReport(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ComparableQuestionsApi - factory interface
 * @export
 */
export const ComparableQuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Endpoint to delete the report of the given ComparableQuestions.      Returns the updated ComparableQuestions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableQuestionsControllerDeleteComparativeReport(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<ComparableQuestions>> {
            return ComparableQuestionsApiFp(configuration).comparableQuestionsControllerDeleteComparativeReport(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Endpoint to delete the given ComparableQuestions. Returns the list of remaining ComparableQuestions for the related ComparableEngagement
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableQuestionsControllerDeleteOne(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ComparableQuestions>>> {
            return ComparableQuestionsApiFp(configuration).comparableQuestionsControllerDeleteOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate a comparative report for a given comparableQuestions
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparableQuestionsControllerGenerateComparativeReport(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return ComparableQuestionsApiFp(configuration).comparableQuestionsControllerGenerateComparativeReport(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComparableQuestionsApi - object-oriented interface
 * @export
 * @class ComparableQuestionsApi
 * @extends {BaseAPI}
 */
export class ComparableQuestionsApi extends BaseAPI {
    /**
     * 
     * @summary Endpoint to delete the report of the given ComparableQuestions.      Returns the updated ComparableQuestions
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparableQuestionsApi
     */
    public async comparableQuestionsControllerDeleteComparativeReport(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<ComparableQuestions>> {
        return ComparableQuestionsApiFp(this.configuration).comparableQuestionsControllerDeleteComparativeReport(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Endpoint to delete the given ComparableQuestions. Returns the list of remaining ComparableQuestions for the related ComparableEngagement
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparableQuestionsApi
     */
    public async comparableQuestionsControllerDeleteOne(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ComparableQuestions>>> {
        return ComparableQuestionsApiFp(this.configuration).comparableQuestionsControllerDeleteOne(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Generate a comparative report for a given comparableQuestions
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparableQuestionsApi
     */
    public async comparableQuestionsControllerGenerateComparativeReport(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return ComparableQuestionsApiFp(this.configuration).comparableQuestionsControllerGenerateComparativeReport(id, options).then((request) => request(this.axios, this.basePath));
    }
}
